import React from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { cn } from '@/lib/utils';

export interface ModalBodyProps {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
  noScroll?: boolean;
}

export const ModalBody: React.FC<ModalBodyProps> = ({
  children,
  className,
  noPadding = false,
  noScroll = false,
}) => {
  const content = (
    <div
      className={cn(
        !noPadding && 'px-4 sm:px-6 py-4',
        'w-full',
        className
      )}
    >
      {children}
    </div>
  );

  if (noScroll) {
    return <div className="flex-1 min-h-0 w-full overflow-auto">{content}</div>;
  }

  return (
    <ScrollArea className="flex-1 min-h-0 w-full">
      {content}
    </ScrollArea>
  );
};
